import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".readonly-address-module_readonlyAddressContainer__9-fec {\n  margin-top: var(--z-size-20px);\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: var(--z-size-15px);\n}\n@media (max-width: 544px) {\n  .readonly-address-module_readonlyAddressContainer__9-fec {\n    grid-template-columns: 1fr;\n  }\n}";
var styles = {"readonlyAddressContainer":"readonly-address-module_readonlyAddressContainer__9-fec"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
//# sourceMappingURL=readonly-address.module.scss.js.map
